/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import { object } from 'prop-types';
import mbpLogger from '@module-logger/mbp';
import { useQuery } from '@apollo/client';

import loadable from '@loadable/component';
import { GRAPHQL_ENV } from '../../../gql';
import findContent from '../../../gql/queries/findContent';
import withPageView from '../../../helpers/tracking/hocs/withPageView';
import { getFeatureFlags } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getPassportData } from '../../../../state/ducks/Passport/Passport-Selectors';
import PassportEnrollmentLander from './CelebrationPassport/PassportEnrollmentLander';
import GraphqlPassportContainer from '../GraphqlPassportContainer/GraphqlPassportContainer';

const PassportBlock = loadable(() => import(/* webpackChunkName: "PassportBlock" */ './PassportBlock'));

const PassportPageV2 = ({
    featureFlags, page, passportData,
}) => {
    const PASSPORT_PAGE_QUERY = findContent({
        brand: 'celebrations',
        locale: 'en-us',
        contentType: 'passport_enrollment_lander',
    });

    const cartIconLabel = featureFlags['cart-icon-label']?.label || 'Cart';

    const { error, data } = useQuery(PASSPORT_PAGE_QUERY);
    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: PASSPORT_PAGE_QUERY,
            component: 'PassportPageV2.js',
            message: `Error loading data from Graphql ${error}`,
            env: GRAPHQL_ENV,
            error,
        });
        return null;
    }
    if (!data) {
        mbpLogger.logWarning({
            appName: process.env.npm_package_name,
            query: PASSPORT_PAGE_QUERY,
            component: 'PassportPageV2.js',
            message: 'No data returned for query',
            env: GRAPHQL_ENV,
        });
        return null;
    }
    if (data?.findContent?.content?.entries?.length > 0) {
        const content = data.findContent.content.entries[0];
        const needsBrandPassport = !passportData?.item_id || !passportData?.brand_id;
        return (
            <>
                {needsBrandPassport && <GraphqlPassportContainer />}
                <PassportEnrollmentLander data={content} cartIconLabel={cartIconLabel} page={page} />
            </>
        );
    }
    return null;
};

PassportPageV2.propTypes = {
    featureFlags: object,
    page: object.isRequired,
    passportData: object,
};

PassportPageV2.defaultProps = {
    featureFlags: {},
    passportData: {},
};

const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
    passportData: getPassportData(state),
});

const enhance = compose(
    withRouter,
    connect(mapStateToProps),
    withPageView({
        pageViewSuccessTest: () => true,
    }),
);

export default enhance(PassportPageV2);
